exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".coaching-core-data[data-v-5f21d5f6] {\n  padding: 20px;\n  background-color: #eff6ff;\n  border-radius: 10px;\n}\n.coaching-core-data .data-list .list-item .count-bold[data-v-5f21d5f6] {\n  font-size: 24px;\n  font-weight: bold;\n}\n", ""]);

// exports
